export default "__VITE_ASSET__eede6c3c__"